import React, { useState, useEffect } from 'react';
import './HayleeDinner.css';

const HayleeDinner = () => {
  const [selectedColor, setSelectedColor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  // Handle clicking outside to close popup
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (message && !event.target.closest('.popup-message')) {
        setMessage('');
      }
    };

    if (message) {
      // Small delay to prevent immediate closing
      setTimeout(() => {
        document.addEventListener('click', handleClickOutside);
      }, 100);
     
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, [message]);

  const handleColorSelect = async (color) => {
    setSelectedColor(color);
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/haylee-dinner`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ color }),
      });

      // Just consume the response without assigning to unused variable
      await response.json();
     
      if (response.ok) {
        setMessage('ok bb.');
      } else {
        setMessage('Oops! Try again?');
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage('Oops! Try again?');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="haylee-dinner-container">
      <div className="haylee-dinner-content">
        <h1 className="haylee-dinner-title">Whatchu Want for Dinner Pretty Girl?</h1>
       
        <div className="color-boxes-container">
          <div
            className={`color-box green-box ${selectedColor === 'green' ? 'selected' : ''} ${loading ? 'disabled' : ''}`}
            onClick={() => !loading && handleColorSelect('green')}
          />
         
          <div
            className={`color-box gold-box ${selectedColor === 'gold' ? 'selected' : ''} ${loading ? 'disabled' : ''}`}
            onClick={() => !loading && handleColorSelect('gold')}
          />
         
          <div
            className={`color-box red-box ${selectedColor === 'red' ? 'selected' : ''} ${loading ? 'disabled' : ''}`}
            onClick={() => !loading && handleColorSelect('red')}
          />
        </div>

        {loading && (
          <div className="loading-message">
            <div className="spinner"></div>
          </div>
        )}

        {message && !loading && (
          <div
            className={`popup-message ${message === 'ok bb.' ? 'success' : 'error'}`}
          >
            <p>{message}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default HayleeDinner;